import { gql } from "@apollo/client";

export const GET_ALL_PAYMENT_ORDERS = gql`
  query GetPaymentOrders($first: Int = 10, $offset: Int = 0, $filter: PaymentOrderFilter!) {
    allPaymentOrders(
      filter: $filter
      first: $first
      offset: $offset
      orderBy: CREATED_AT_DESC
    ) {
      nodes {
        pmtPOrderId
        pmtMOrderId
        pmtId
        prId
        sId
        studentBySId {
          userByUId {
            uFullName
            uFirstName
            uEmailId
            uCognitoId
          }
          studentRegistrationsBySId {
            nodes {
              srCommunicationEmail
              srCommunicationPhone
              srGuardianName
              srDetails
            }
          }
        }
        paymentStatusTypeByPstId {
          pstName
          pstId
        }
      }
      totalCount
    }
  }
`;

export const UPDATE_PAYMENT_RECORD_STATUS = gql`
  mutation UpdatePaymentRecordStatus($input: updatePaymentRecordStatusInput!) {
    updatePaymentRecordStatus(input: $input) {
      message
      pmtId
      status
    }
  }
`;

export const GET_ALL_PAYMENT_STATUS_TYPES = gql`
query allPaymentStatusTypes {
  allPaymentStatusTypes(
    filter: {isFilterView: {equalTo: true}, deletedAt: {isNull: true}}
  ) {
    nodes {
      pstId
      pstName
    }
  }
}
`;


